// ** Gatsby
import { GatsbyImage } from "gatsby-plugin-image"

// ** Custom Components
import Box from "../Box"
import Container from "../Container"
import Heading from "../Heading"

const SectionSupport = ({ section }: any) => {
  const { title, listItems } = section
  return (
    <Container
      className="flex flex-col w-full gap-10 md:mt-14"
      fullWidthOnMobile={false}
      constrainedToBreakPoint
    >
      <Heading as="h4" className="text-blue-500">
        {title}
      </Heading>
      <Box className="grid gap-y-8 md:grid-rows-5 md:grid-flow-col">
        {listItems.map((item: any, idx: any) => (
          <Box
            key={idx}
            className="flex flex-col md:flex-row justify-center items-center gap-4 md:justify-start"
          >
            <GatsbyImage
              image={item.Image?.asset?.gatsbyImageData}
              alt={item.Image?.asset?.altText || "section support"}
              className="h-[71px] w-[71px]"
              objectFit="contain"
            />
            <Heading
              as="h6"
              className="text-blue-500 max-w-[75%] md:w-full text-center md:text-left"
            >
              {item.title}
            </Heading>
          </Box>
        ))}
      </Box>
    </Container>
  )
}

export default SectionSupport
